// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"92e424d5","147":"92e424d5","422":"92e424d5","514":"92e424d5","932":"92e424d5"}[chunkId] + ".chunk.css";
};